// ================================================================================
// wp-block-station-finder.js
// TOYOTA SHARE ステーションのスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { Thumbs, FreeMode, Autoplay, Navigation, Pagination } from 'swiper/modules';

/* global google, Swiper */
document.addEventListener('DOMContentLoaded', function() {
	var root = document.querySelector('.js-station-finder');
	if (!root) return;

	var stationData = readJsonFromDom(root, '.js-station-finder-data');
	if (!stationData.length) return;

	var listEl = root.querySelector('#js-cn-station-list');
	if (!listEl) return;

	var allDataHtml = listEl.innerHTML;

	var selectEl = root.querySelector('.js-station-search-select');

	// 初期連番（初期HTML分）
	numberItems();

	initSwipers(listEl);

	// 初回Map
	waitForGoogleMaps(function() {
		renderMap({
			value: '',
			data: stationData
		});
	});

	// route click（data-id）
	root.querySelectorAll('.js-route-list-link').forEach(function(el) {
		el.addEventListener('click', function(e) {
			e.preventDefault();

			var val = el.getAttribute('data-id') || '';
			var href = el.getAttribute('href') || '';

			if (!val) return;

			stationFilter(val);

			if (selectEl) selectEl.value = val;

			if (href && href.startsWith('#')) {
				var target = document.querySelector(href);
				if (target) {
					smoothScrollTo(target, 10, 100);
				}
			}
		});
	});

	// select change
	if (selectEl) {
		selectEl.addEventListener('change', function() {
			var val = selectEl.value || '';

			if (val) {
				stationFilter(val);
				return;
			}

			// reset
			listEl.innerHTML = allDataHtml;
			numberItems();
			initSwipers(listEl);

			waitForGoogleMaps(function() {
				renderMap({
					value: '',
					data: stationData
				});
			});
		});
	}

	// マーカー内リンク（委譲）
	document.addEventListener('click', function(e) {
		var link = e.target.closest('.js-stationSearchItem__link');
		if (!link) return;

		e.preventDefault();

		var href = link.getAttribute('href') || '';
		if (!href || href === '#') return;

		var target = document.querySelector(href);
		if (!target) return;

		smoothScrollTo(target, 50, 400);
	});

	function readJsonFromDom(rootEl, selector) {
		var el = rootEl.querySelector(selector);
		if (!el) return [];

		try {
			var json = JSON.parse(el.textContent || '[]');
			return Array.isArray(json) ? json : [];
		} catch (e) {
			return [];
		}
	}

	function numberItems() {
		root.querySelectorAll('.js-cn-station-item').forEach(function(item, i) {
			var numEl = item.querySelector('.js-storeResultsCard__numText');
			if (numEl) numEl.textContent = String(i + 1);
		});
	}

	function canUseGoogleMaps() {
		return !!(window.google && google.maps && google.maps.Map);
	}

	function waitForGoogleMaps(callback) {
		var limit = 200;
		var count = 0;

		function tick() {
			if (canUseGoogleMaps()) {
				callback();
				return;
			}
			count++;
			if (count >= limit) return;
			setTimeout(tick, 50);
		}

		tick();
	}

	function toLatLng(lat, lng) {
		var latNum = parseFloat(lat);
		var lngNum = parseFloat(lng);
		if (Number.isNaN(latNum) || Number.isNaN(lngNum)) return null;
		return { lat: latNum, lng: lngNum };
	}

	// map描画（元コード踏襲）
	function renderMap(opts) {
		if (!canUseGoogleMaps()) return;

		var mapArea = document.getElementById('js-stationMap');
		if (!mapArea) return;

		var value = opts.value;
		var data = Array.isArray(opts.data) ? opts.data : [];

		var myOptions;
		if (value) {
			myOptions = {
				zoom: 16,
				center: toLatLng(data[0] && data[0].lat, data[0] && data[0].lng) || { lat: 35.906589, lng: 139.623248 },
				mapTypeId: 'roadmap'
			};
		} else {
			myOptions = {
				zoom: 11,
				center: { lat: 35.906589, lng: 139.623248 },
				mapTypeId: 'roadmap'
			};
		}

		var map = new google.maps.Map(mapArea, myOptions);
		var bounds = new google.maps.LatLngBounds();
		var currentWindow = null;

		for (var i = 0; i < data.length; i++) {
			var item = data[i];

			var latlng = toLatLng(item.lat, item.lng);
			if (!latlng) continue;

			var number = String(i + 1);

			var iconImage = '/wp-content/themes/toyota-rlss/assets/images/toyotashare/icon_store_place_red.png';

			var icons = {
				url: iconImage,
				size: new google.maps.Size(26, 44),
				origin: new google.maps.Point(0, -4),
			};

			createMarker({
				name: item.title,
				latlng: latlng,
				icons: icons,
				number: number,
				map: map,
				zipcode: item.zip,
				address: item.address,
				id: item.id,
				term: item.term,
				category: item.category,
				image: item.image,
				car: item.car,
				getCurrentWindow: function() { return currentWindow; },
				setCurrentWindow: function(v) { currentWindow = v; }
			});

			bounds.extend(latlng);
		}

		// fitBounds（selectが空でない && 2件以上）
		var selectVal = selectEl ? (selectEl.value || '') : '';
		if (selectVal !== '' && data.length > 1) {
			map.fitBounds(bounds, 1);
		}

		// valueありなら setZoom(16)（元コード踏襲）
		if (value) {
			setTimeout(function() {
				map.setZoom(16);
			}, 1);
		}
	}

	function createMarker(opts) {
		var fullAddress = '〒' + safeText(opts.zipcode) + ' ' + safeText(opts.address);

		var contentString = '<div class="p-stationSearchItem" id="content">';

		if (opts.image && Array.isArray(opts.image) && opts.image[0]) {
			contentString += '<p class="p-stationSearchItem__image"><img src="' + escAttr(opts.image[0]) + '" alt=""></p>';
		}

		contentString += '<h2 class="p-stationSearchItem__title">' + safeText(opts.name) + '</h2>';

		contentString += '<div class="p-stationSearchItem__body">';
			contentString += '<p>' + fullAddress + '</p>';

			if (opts.car) {
				contentString += '<dl><dt>車種：</dt><dd>' + safeText(opts.car) + '</dd></dl>';
			}
		contentString += '</div>';

		contentString += '<p class="p-stationSearchItem__button is-toyota-share"><a href="#station-' + escAttr(opts.id) + '" class="js-stationSearchItem__link">詳細を見る</a></p>';
		contentString += '</div>';

		var infoWindow = new google.maps.InfoWindow();

		var marker = new google.maps.Marker({
			position: opts.latlng,
			map: opts.map,
			icon: opts.icons,
			label: {
				text: opts.number,
				color: '#fff',
			}
		});

		google.maps.event.addListener(marker, 'click', function() {
			var current = opts.getCurrentWindow();
			if (current) current.close();

			infoWindow.setContent(contentString);
			infoWindow.open(opts.map, marker);
			opts.setCurrentWindow(infoWindow);
		});
	}

	function stationFilter(id) {
		var filterData = stationData.filter(function(elem) {
			return String(elem.term || '').match(id);
		});

		// map更新
		waitForGoogleMaps(function() {
			renderMap({
				value: id,
				data: filterData
			});
		});

		// list更新
		listEl.innerHTML = buildStationListHtml(filterData);
		numberItems();
		initSwipers(listEl);
	}

	function safeTextWithBr(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;')
			.replace(/&lt;br\s*\/?&gt;/gi, '<br>');
	}

	function buildStationListHtml(list) {
		var html = '';

		for (var h = 0; h < list.length; h++) {
			var item = list[h];

			var category = String(item.category || '');
			var title = safeText(item.title);
			var zipcode = safeText(item.zip);
			var address = safeText(item.address);
			var description = safeTextWithBr(item.description);
			var id = escAttr(item.id);

			var image = Array.isArray(item.image) ? item.image : [];
			var carCn = Array.isArray(item.car_cn) ? item.car_cn : [];
			var carTs = Array.isArray(item.car_ts) ? item.car_ts : [];

			var number = h + 1;

			html += '<div class="p-cn-station-item js-cn-station-item" id="station-' + id + '">';
				html += '<div class="p-cn-station-item__container">';

					html += '<h3 class="p-cn-station-title">';
						html += '<span class="p-cn-station-title-point">' + number + '</span>';
						html += '<strong>' + title + '</strong>';
					html += '</h3>';

					html += '<p class="p-cn-station-address">';
						html += '〒' + zipcode + '<br>';
						html += address;
					html += '</p>';

					if (description) {
						html += '<div class="p-cn-station-description">';
							html += description;
						html += '</div>';
					}

					html += '<div class="p-cn-station-cars">';

						if (category.match('chokunori') && carCn.length) {
							html += '<div class="p-cn-station-cars__item">';
								for (var i = 0; i < carCn.length; i++) {
									html += buildCarInfoHtml(carCn[i]);
								}
							html += '</div>';
						}

						if (category.match('toyota-share') && carTs.length) {
							html += '<div class="p-cn-station-cars__item">';
								for (var j = 0; j < carTs.length; j++) {
									html += buildCarInfoHtml(carTs[j]);
								}
							html += '</div>';
						}

					html += '</div>';
				html += '</div>';

				html += '<div class="p-cn-station-item__swiper">';
					if (image.length === 1) {
						html += '<div class="swiper-container">';
					} else {
						html += '<div class="swiper-container js-station-swiper">';
					}

						html += '<div class="swiper-wrapper">';
							for (var k = 0; k < image.length; k++) {
								html += '<div class="swiper-slide">';
									html += '<img src="' + escAttr(image[k]) + '" alt="">';
								html += '</div>';
							}
						html += '</div>';

						if (image.length > 1) {
							html += '<div class="swiper-pagination"></div>';
							html += '<div class="swiper-button-prev"></div>';
							html += '<div class="swiper-button-next"></div>';
						}

					html += '</div>';
				html += '</div>';
			html += '</div>';
		}

		return html;
	}

	function buildCarInfoHtml(v) {
		var name = safeText(v && v.name);
		var cls = safeText(v && v.class);
		var num = safeText(v && v.number);

		return (
			'<dl class="p-cn-station-car-info">' +
				'<dt>' + name + '<span>（' + cls + '）</span></dt>' +
				'<dd>' + num + '台</dd>' +
			'</dl>'
		);
	}

	function initSwipers(containerEl) {
		if (typeof Swiper === 'undefined') return;

		var els = containerEl.querySelectorAll('.js-station-swiper');
		if (!els.length) return;

		els.forEach(function(el) {
			if (el.swiper) el.swiper.destroy(true, true);

			new Swiper(el, {
				modules: [Navigation, Pagination],
				autoplay: false,
				loop: false,
				slidesPerView: 'auto',
				spaceBetween: 10,
				breakpoints: {
					750: {
						slidesPerView: 1,
						spaceBetween: 0
					}
				},
				pagination: {
					el: el.querySelector('.swiper-pagination')
				},
				navigation: {
					nextEl: el.querySelector('.swiper-button-next'),
					prevEl: el.querySelector('.swiper-button-prev')
				}
			});
		});
	}

	function safeText(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	function escAttr(str) {
		return safeText(str);
	}

	function smoothScrollTo(targetEl, adjust, duration) {
		var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
		var rect = targetEl.getBoundingClientRect();
		var targetY = startY + rect.top - (adjust || 0);

		var startTime = performance.now();

		function easeInOutCubic(t) {
			return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
		}

		function step(now) {
			var elapsed = now - startTime;
			var d = duration || 400;
			var p = Math.min(elapsed / d, 1);
			var eased = easeInOutCubic(p);

			window.scrollTo(0, startY + (targetY - startY) * eased);

			if (p < 1) requestAnimationFrame(step);
		}

		requestAnimationFrame(step);
	}
});
